module.exports = __webpack_public_path__ + "img/topic-lost.ae5e1b14.svg";